module.exports = __webpack_public_path__ + "static/media/movily1.faa5db38.PNG";